import { createAction } from "@reduxjs/toolkit"

export const isFactoryResetUpdate = createAction("IS_FACTORY_RESET_UPDATE")
export const ganttDurationUpdate = createAction("GANTT_DURATION_UPDATE")
export const messageFromAppDelete = createAction("MESSAGE_FROM_APP_DELETE")
export const isExamOnUpdate = createAction("IS_EXAM_ON_UPDATE")
export const isDebugOnUpdate = createAction("IS_DEBUG_ON_UPDATE")
